/**
 * @file: ai-credit.service.ts
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 */

import { HttpClient } from '@euler/lib/request';
import { AiCreditStoreBalanceView } from '@euler/model/AiCreditStoreBalanceView';

export class AiCreditService {
  constructor(private readonly api: HttpClient) {}

  /** The balance of the store the token is scoped to. */
  async getStoreBalance(): Promise<AiCreditStoreBalanceView> {
    return await this.api.get().url('/ai-credits/balance').future();
  }
}
